function attachNormalClickTracker(adobject, wrapperId, videoElementId) {
    // Get elements in the same nativeContent as video
    const iconwrapperId = document.getElementById(`${wrapperId}_iconwrapper`);
    const sponsoredBy = document.getElementById(`${wrapperId}_sponsoredBy`);
    const text = document.getElementById(`${wrapperId}_text`);
    let videoElement;
    if (videoElementId) {
        videoElement = document.getElementById(videoElementId);
    }
    const { clickUrl } = adobject.native;
    if (iconwrapperId) {
        iconwrapperId.addEventListener("click", () => {
            window.open(clickUrl, "_blank");
        }, true);
    }
    if (videoElement) {
        videoElement.addEventListener("click", (e) => {
            e.stopPropagation();
        }, true);
    }
    if (sponsoredBy) {
        sponsoredBy.addEventListener("click", () => {
            window.open(clickUrl, "_blank");
        }, true);
    }
    if (text) {
        text.addEventListener("click", () => {
            window.open(clickUrl, "_blank");
        }, true);
    }
}
function attachSocialMediaClickTracker(adobject, wrapperId, videoElementId) {
    const targetE = window.document.getElementById(adobject.targetId);
    if (adobject.native.video) {
        const { clickUrl } = adobject.native;
        const upperwrapperId = document.getElementById(`${wrapperId}_upper_wrapper`);
        let videoElement;
        if (videoElementId) {
            videoElement = document.getElementById(videoElementId);
        }
        const bodyText = document.getElementById(`${wrapperId}_bodyText`);
        const footer = document.getElementById(`${wrapperId}_footer`);
        if (upperwrapperId) {
            upperwrapperId.addEventListener("click", () => {
                window.open(clickUrl, "_blank");
            }, true);
        }
        if (videoElement) {
            videoElement.addEventListener("click", (e) => {
                e.stopPropagation();
            }, true);
        }
        if (bodyText) {
            bodyText.addEventListener("click", () => {
                window.open(clickUrl, "_blank");
            }, true);
        }
        if (footer) {
            footer.addEventListener("click", () => {
                window.open(clickUrl, "_blank");
            }, true);
        }
    }
    else if (targetE) {
        targetE.onclick = () => window.open(adobject.native.clickUrl, "_blank");
    }
}
const titleLimit = 80;
function addTemplate(template) {
    return { ...template, name: template.name };
}
export { attachNormalClickTracker, attachSocialMediaClickTracker, titleLimit, addTemplate, };
//# sourceMappingURL=native-helpers.js.map